'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = _interopDefault(require('react'));

var PropTypes = _interopDefault(require('prop-types'));

var cx = _interopDefault(require('classnames'));

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".loading-indicator-container {\n  pointer-events: none;\n  position: fixed;\n  text-align: center;\n  height: 5em;\n  width: 5em;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n      -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%); }\n  .loading-indicator-container,\n  .loading-indicator-container *,\n  .loading-indicator-container *:before,\n  .loading-indicator-container *:after {\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box; }\n  .loading-indicator-container.absolute {\n    position: absolute; }\n  .loading-indicator-container .segment {\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 10; }\n    .loading-indicator-container .segment svg {\n      width: 100%;\n      height: 100%; }\n    .loading-indicator-container .segment.small {\n      -webkit-animation: loading-indicator-spin 500ms linear 0ms infinite running;\n              animation: loading-indicator-spin 500ms linear 0ms infinite running; }\n    .loading-indicator-container .segment.small-2 {\n      -webkit-animation: loading-indicator-spin 600ms linear 0ms infinite running;\n              animation: loading-indicator-spin 600ms linear 0ms infinite running; }\n    .loading-indicator-container .segment.medium {\n      -webkit-animation: loading-indicator-spin 650ms linear 0ms infinite running;\n              animation: loading-indicator-spin 650ms linear 0ms infinite running; }\n    .loading-indicator-container .segment.large {\n      -webkit-animation: loading-indicator-spin 850ms linear 0ms infinite running;\n              animation: loading-indicator-spin 850ms linear 0ms infinite running; }\n    .loading-indicator-container .segment.dark {\n      -webkit-animation: loading-indicator-spin 700ms linear 0ms infinite running;\n              animation: loading-indicator-spin 700ms linear 0ms infinite running; }\n    .loading-indicator-container .segment.dark-2 {\n      -webkit-animation: loading-indicator-spin 900ms linear 0ms infinite running;\n              animation: loading-indicator-spin 900ms linear 0ms infinite running; }\n\n@-webkit-keyframes loading-indicator-spin {\n  from {\n    -webkit-transform: rotate(0turn);\n            transform: rotate(0turn); }\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn); } }\n\n@keyframes loading-indicator-spin {\n  from {\n    -webkit-transform: rotate(0turn);\n            transform: rotate(0turn); }\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn); } }\n";
styleInject(css);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var segmentDark = function segmentDark() {
  return React.createElement('svg', {
    width: '75',
    height: '75',
    viewBox: '0 0 200 200',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M55.4306 82.1795C45.758 106.371 57.1975 133.821 80.9785 144.07C84.0216 145.381 85.4253 148.912 84.1138 151.955C82.8022 154.998 79.2721 156.402 76.229 155.09C46.4923 142.274 32.1946 107.971 44.2883 77.7244C45.5185 74.6475 49.0101 73.1505 52.087 74.3808C55.1639 75.611 56.6609 79.1026 55.4306 82.1795Z',
    fill: '#2D4277'
  }));
};

var segmentLarge = function segmentLarge() {
  return React.createElement('svg', {
    width: '75',
    height: '75',
    viewBox: '0 0 200 200',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M55.4306 82.1795C45.5964 106.775 57.5838 134.735 82.1795 144.569C91.8585 148.439 102.042 148.93 111.449 146.609C114.666 145.814 117.918 147.779 118.712 150.996C119.506 154.213 117.541 157.465 114.324 158.259C102.566 161.161 89.8138 160.545 77.7244 155.712C46.9749 143.417 31.9935 108.474 44.2883 77.7244C45.5185 74.6475 49.0101 73.1505 52.087 74.3808C55.1639 75.611 56.6609 79.1026 55.4306 82.1795Z',
    fill: '#82F0F2'
  }));
};

var segmentMedium = function segmentMedium() {
  return React.createElement('svg', {
    width: '75',
    height: '75',
    viewBox: '0 0 200 200',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M152.08 84.5172C155.341 83.9294 158.461 86.0966 159.049 89.3578C161.764 104.426 158.582 119.214 151.163 131.32C149.432 134.146 145.738 135.033 142.912 133.301C140.087 131.57 139.2 127.876 140.931 125.051C146.873 115.354 149.412 103.541 147.239 91.4862C146.651 88.2251 148.818 85.1049 152.08 84.5172Z',
    fill: '#82F0F2'
  }));
};

var segmentSmall = function segmentSmall() {
  return React.createElement('svg', {
    width: '75',
    height: '75',
    viewBox: '0 0 200 200',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M137.566 60.7474C140.108 58.6211 143.892 58.9576 146.018 61.4992C146.709 62.3241 147.37 63.1593 148.005 64.0045C149.995 66.6538 149.461 70.4151 146.812 72.4055C144.162 74.3959 140.401 73.8617 138.411 71.2124C137.898 70.53 137.367 69.8592 136.815 69.1993C134.688 66.6578 135.025 62.8738 137.566 60.7474Z',
    fill: '#82F0F2'
  }));
};

function Loading(_ref) {
  var absolute = _ref.absolute,
      zIndex = _ref.zIndex,
      props = objectWithoutProperties(_ref, ['absolute', 'zIndex']);
  return React.createElement('div', _extends({
    className: cx('loading-indicator-container css-loader', {
      absolute: absolute
    }),
    style: {
      zIndex: zIndex
    }
  }, props), React.createElement('div', {
    className: 'segment medium'
  }, segmentMedium()), React.createElement('div', {
    className: 'segment small'
  }, segmentSmall()), React.createElement('div', {
    className: 'segment large'
  }, segmentLarge()), React.createElement('div', {
    className: 'segment dark'
  }, segmentDark()), React.createElement('div', {
    className: 'segment dark-2'
  }, segmentDark()), React.createElement('div', {
    className: 'segment small-2'
  }, segmentSmall()));
}

Loading.defaultProps = {
  zIndex: null
};
Loading.propTypes = {
  absolute: PropTypes.bool,
  zIndex: PropTypes.number
};
exports.default = Loading;